export class NewDetectionSetting {
    nameSetting!: string;
    takeFrom?: string;
  }